import { Component, Input, OnInit, signal } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EvaluationService } from "app/services/evaluation/evaluation.service";
import moment from "app/util/dayjs";

@Component({
    selector: "componente-objetivos-forzados",
    templateUrl: "./componente-objetivos-forzados.component.html",
    styleUrls: ["./componente-objetivos-forzados.component.scss"],
    standalone: false
})
export class ComponenteObjetivosForzadosComponent implements OnInit {
    readonly planesForzados = signal<any[]>([]);

    @Input() idPeriodo: string;

    @Input() idPersona: string;

    constructor(
        private evaluationSvc: EvaluationService,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.evaluationSvc
            .getSolicitudesParaUsuario(Number(this.idPeriodo), Number(this.idPersona))
            .subscribe((data) => {
                this.planesForzados.set(data?.solicitudes || []);
            });
    }

    formatDate(dateString: string): string {
        return moment(dateString).format("DD/MM/YYYY");
    }
}
